import React, { useState, useCallback, useEffect } from "react";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import { toast } from "react-hot-toast";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import RecentActorsOutlinedIcon from "@mui/icons-material/RecentActorsOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
// import TopicIcon from '@mui/icons-material/Topic';
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import { useNavigate } from "react-router-dom";
import { SERVER_ORIGIN } from "../../utilities/constants";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Modal, Row, Col, Alert } from "react-bootstrap";
import SecCard from "../../components/common/SecCard";
import userTypeModalCss from "../../css/common/user-type-modal.module.css";
import EM from "../../css/chapterEM/add-chapterEM.module.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import css from "../../css/admin/home-page.module.css";
import { useDropzone } from "react-dropzone";
import upload_img from "../../assets/images/Download-bro.svg";
import TermsAndConditionsModal from "./TermsAndConditionsModal";

// const DateSelect = ({ selectedYear, handleYearChange }) => {
//     const handleChange = (date) => {
//         if (date) {
//             handleYearChange({
//                 target: {
//                     name: "signDate", value: `${date.getMonth() + 1}/${date.getDate()
//                         }/${date.getFullYear()}`
//                 }
//             });
//         }
//         console.log(date, "date");
//     };

//     return (
//         <DatePicker
//             selected={selectedYear}
//             onChange={handleChange}
//             // showYearPicker
//             // dateFormat="yyyy"
//             className={`${EM.chapterEMInput} w-100`}
//             placeholderText="Select Sign Date"

//         />
//     );
// };
// const DateSelect = ({ selectedYear, handleYearChange }) => {
//   const handleChange = (date) => {
//     if (date) {
//       handleYearChange({
//         target: {
//           name: "signDate",
//           value: `${date.getDate()}/${
//             date.getMonth() + 1
//           }/${date.getFullYear()}`,
//         },
//       });
//     }
//     console.log(date, "date");
//   };

//   return (
//     <DatePicker
//       selected={
//         selectedYear
//           ? new Date(selectedYear.split("/").reverse().join("-"))
//           : null
//       }
//       onChange={handleChange}
//       dateFormat="dd/MM/yyyy"
//       className={`${EM.chapterEMInput} w-100`}
//       placeholderText="Select Sign Date"
//     />
//   );
// };

const DateInput = ({ value, onChange, disabled }) => {
  const [dateValue, setDateValue] = useState("");

  useEffect(() => {
    if (!value) return setDateValue("");
    // Convert ISO / yyyy-mm-dd to yyyy-mm-dd (for input type=date)
    const isoDate = new Date(value).toISOString().split("T")[0];
    setDateValue(isoDate);
  }, [value]);

  const handleChange = (e) => {
    const inputVal = e.target.value; // yyyy-mm-dd
    setDateValue(inputVal);
    onChange({
      target: { name: "signDate", value: inputVal }, // keep ISO format in state
    });
  };

  return (
    <input
      type="date"
      className="w-100 form-control"
      value={dateValue}
      onChange={handleChange}
      disabled={disabled}
    />
  );
};

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    disableScrollLock={true}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function CustomizedMenus({ _id, activeTab = "institute" }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userType, setUserType] = React.useState(null);
  const [openDialog, setOpenDialog] = React.useState(false);
  // const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [formLocked, setFormLocked] = useState(false);

  // Terms and Conditions state
  const [termsData, setTermsData] = useState(null);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isLoadingTerms, setIsLoadingTerms] = useState(false);
  const [instituteData, setInstituteData] = useState(null);

  const [selectedImage1, setSelectedImage1] = useState(null);
  const [imageBlob1, setImageBlob1] = useState(null);
  const [selectedImage2, setSelectedImage2] = useState(null);
  const [imageBlob2, setImageBlob2] = useState(null);
  const [instituteForm, setInstituteForm] = useState({
    instituteName: "",
    nodalName: "",
    officeLocation: "",
    signatoryDesignation: "",
    mouDuration: "",
    signDate: "",
  });
  const [loading, setLoading] = useState(false);
  // const [mouURL, setMouUrl] = useState(`https://yuvaportal.youngindians.net/new-mou-sample-pdf.pdf`)
  const [mouURL, setMouUrl] = useState(
    `https://yuva.evalue8.info/new-mou-sample-pdf.pdf`
  );

  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => {
    const userType = sessionStorage.getItem("userType");
    setUserType(userType);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDigitalSign = async () => {
    try {
      const response = await fetch(
        `${SERVER_ORIGIN}/api/em/auth/approve-digital-sign`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": sessionStorage.getItem("token"),
          },
          body: JSON.stringify({ _id: _id }),
        }
      );
      const result = await response.json();
      if (!response.status >= 300) {
        throw new Error("Failed, something went wrong");
      } else {
        toast.success(result.statusText);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
    handleClose();
    handleClose2();
  };

  const handleManageAccounts = () => {
    handleClose();
    if (sessionStorage.getItem("userType") === "em") {
      navigate(`/institute-profile/${_id}`);
    } else {
      navigate(`/admin/institute-profile/${_id}`);
    }
  };
  const isoToDDMMYYYY = (isoStr) => {
    if (!isoStr) return "";
    const date = new Date(isoStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    (async function () {
      try {
        const response = await fetch(
          `${SERVER_ORIGIN}/api/institute/auth/check-mou`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem("token"),
            },
            body: JSON.stringify({ _id: _id }),
          }
        );
        const result = await response.json();
        if (!response.status >= 300) {
          throw new Error("Failed to upload PDFs");
        } else {
          if (result.data.docUrl.includes(".pdf")) {
            setMouUrl(result.data.docUrl);
          }
          // console.log(result,"http://localhost:8080/663d2ba6009ef886dd687f5f_mou.pdf");
          setInstituteForm({
            instituteName: result.data.name,
            nodalName: result.data.officerName,
            officeLocation: result.data.city + ", " + result.data.state,
            signatoryDesignation: result.data.designation ?? "",
            mouDuration: result.data.mouDuration,
            signDate: result.data.signDate
              ? result.data.signDate.split("T")[0]
              : "",

            // signDate: result.data.signDate,
            // signDate: isoToDDMMYYYY(result.data.signDate), // <-- convert here
          });
        }
      } catch (error) {
        toast.error(error.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } finally {
        setLoading(false);
      }
    })();
  }, [_id]);

  const handleInvitedStudents = () => {
    handleClose();
    if (sessionStorage.getItem("userType") === "em") {
      navigate(`/institute-students/${_id}`);
    } else {
      navigate(`/admin/institute-students/${_id}`);
    }
  };
  const handleAllMouUploaded = () => {
    handleClose();
    if (sessionStorage.getItem("userType") === "em") {
      navigate(`/institute/mou/all/${_id}`);
    } else {
      navigate(`/admin/institute/mou/all/${_id}`);
    }
  };

  const handleShareRegistrationLink = async () => {
    handleClose();
    try {
      // Generate the public registration link with institute ID and tab type
      const tabType = activeTab === "thalir" ? "thalir" : "institute";
      const registrationLink = `${
        window.location.origin
      }/user/register/${_id}?public=${true}&tab=${tabType}`;

      // Copy to clipboard
      await navigator.clipboard.writeText(registrationLink);

      toast.success(
        `${
          tabType === "thalir" ? "Thalir" : "YUVA"
        } student registration link copied to clipboard!`
      );
    } catch (error) {
      // Fallback for older browsers
      const tabType = activeTab === "thalir" ? "thalir" : "institute";
      const textArea = document.createElement("textarea");
      textArea.value = `${
        window.location.origin
      }/user/register/${_id}?public=${true}&tab=${tabType}`;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);

      toast.success(
        `${
          tabType === "thalir" ? "Thalir" : "YUVA"
        } student registration link copied to clipboard!`
      );
    }
  };

  const handleDeleteClick = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDeleteConfirm = async () => {
    try {
      const response = await fetch(
        `${SERVER_ORIGIN}/api/institute/auth/dlt/${_id}`,
        {
          method: "POST",
          headers: {
            "auth-token": sessionStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );
      const result = await response.json();
      if (response.status >= 300) {
        toast.error(result.statusText);
      } else {
        toast.success(result.statusText);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
    handleDialogClose();
    handleClose();
  };
  const onChange = (e) => {
    const { name, value } = e.target;
    setInstituteForm({ ...instituteForm, [name]: value });
  };

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  const handleClose2 = () => {
    setShow2(false);
    setTermsData(null);
    setTermsAccepted(false);
  };
  const handleShow2 = () => {
    setShow2(true);
    fetchTermsAndConditions();
  };
  // const handelManualUpload = () => setIsMouManual(true)
  const handleClick2 = () => {
    // handleClose();
    handleShow2();
    // handelManualUpload();
    handleClose();
  };

  const handleInputChange = (e) => {
    setInstituteForm({ ...instituteForm, [e.target.name]: e.target.value });
  };

  const logImageBlob = async () => {
    if (!instituteForm.mouDuration) {
      toast.error("Please fill MOU duration");
    } else if (!instituteForm.signDate) {
      toast.error("Please fill sign date");
    } else {
      loadMouData();
    }
    // }
  };

  const loadMouData = async () => {
    setLoading(true);
    try {
      const institute_id = _id;
      const formData = new FormData();
      formData.append("instituteName", instituteForm.instituteName);
      formData.append("nodalName", instituteForm.nodalName);
      formData.append("officeLocation", instituteForm.officeLocation);
      formData.append(
        "signatoryDesignation",
        instituteForm.signatoryDesignation
      );
      formData.append("mouDuration", instituteForm.mouDuration);
      formData.append("institute_id", institute_id);
      // formData.append("signDate", instituteForm.signDate);
      const [year, month, day] = instituteForm.signDate.split("-");

      formData.append("signDate", `${day}/${month}/${year}`);

      formData.append("document_file", imageBlob1);
      formData.append("document_file", imageBlob2);
      const response = await fetch(
        `${SERVER_ORIGIN}/api/institute/auth/${
          !selectedImage2 ? "modify-pdf" : "manual-mou"
        }`,
        {
          method: "POST",
          headers: {
            "auth-token": sessionStorage.getItem("token"),
          },
          body: formData,
        }
      );
      const result = await response.json();
      // console.log(result);
      if (!response.status >= 300) {
        throw new Error("Failed to upload PDFs");
      } else {
        setSelectedImage1(null);
        toast.success("File uploaded successfully");
        setLoading(false);
        // console.log(result)
        // toast.success('MOU Updated Successfully');
      }
      handleClose();
    } catch (error) {
      // toast.error('Failed to Update MOU');
      // console.log(error);
      toast.error(error.message);
    } finally {
      setLoading(false);
      // setTimeout(() => {
      //     window.location.reload();
      // }, 2000);
    }
  };
  const onDrop2 = useCallback((acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      if (file.type === "application/pdf") {
        setSelectedImage2(URL.createObjectURL(file));
        setImageBlob1(file);
      } else {
        toast.error("Only .pdf files are allowed.");
      }
    }
  }, []);
  const clearImage2 = () => {
    setSelectedImage2(null);
    setImageBlob2(null);
    toast.success("File removed successfully");
  };

  // const { getRootProps: getRootProps1, getInputProps: getInputProps1, isDragActive: isDragActive1 } = useDropzone({ onDrop: onDrop1 });
  const {
    getRootProps: getRootProps2,
    getInputProps: getInputProps2,
    isDragActive: isDragActive2,
  } = useDropzone({ onDrop: onDrop2 });

  // Get current financial year (April to March cycle)
  const getCurrentFinancialYear = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // 0-indexed month

    if (currentMonth >= 4) {
      // April onwards, financial year is current year to next year
      return `${currentYear}-${(currentYear + 1).toString().slice(-2)}`;
    } else {
      // January to March, financial year is previous year to current year
      return `${currentYear - 1}-${currentYear.toString().slice(-2)}`;
    }
  };

  // Add token validation helper
  const validateAndRefreshToken = async () => {
    const token = sessionStorage.getItem("token");
    const userType = sessionStorage.getItem("userType");

    if (!token) {
      throw new Error("No authentication token found");
    }

    try {
      // Verify token is still valid by calling a verification endpoint
      let verifyEndpoint = "";
      let headers = {
        "Content-Type": "application/json",
        "auth-token": token,
      };

      // Choose the correct verification endpoint based on user type
      if (userType === "admin") {
        verifyEndpoint = `${SERVER_ORIGIN}/api/admin/auth/verify-token`;
        const adminId = process.env.REACT_APP_ADMIN_ID;
        const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;
        const basicAuth = btoa(`${adminId}:${adminPassword}`);
        headers.Authorization = `Basic ${basicAuth}`;
      } else if (userType === "em") {
        verifyEndpoint = `${SERVER_ORIGIN}/api/em/auth/verify-token`;
      } else if (userType === "institute") {
        verifyEndpoint = `${SERVER_ORIGIN}/api/institute/auth/verify-token`;
      } else if (userType === "regionem") {
        verifyEndpoint = `${SERVER_ORIGIN}/api/regionem/auth/verify-token`;
      } else {
        throw new Error(`Unsupported user type: ${userType}`);
      }

      const response = await fetch(verifyEndpoint, {
        method: "POST",
        headers: headers,
      });

      if (!response.ok) {
        const errorResult = await response.json();
        console.error("Token verification failed:", errorResult);
        throw new Error("Token verification failed");
      }

      return { token, userType };
    } catch (error) {
      console.error("Token validation error:", error);
      throw error;
    }
  };

  const fetchTermsAndConditions = async () => {
    setIsLoadingTerms(true);
    try {
      // Validate authentication first
      console.log("Debug: Validating authentication...");
      const { token, userType } = await validateAndRefreshToken();

      console.log("Debug: Auth validated successfully");
      console.log("Debug: User type:", userType);
      console.log("Debug: Institute ID:", _id);

      // First, get institute details to find the Chapter EM
      console.log("Debug: Fetching institute details...");
      const instituteResponse = await fetch(
        `${SERVER_ORIGIN}/api/institute/auth/users/${_id}`,
        {
          headers: {
            "auth-token": token,
          },
        }
      );

      console.log(
        "Debug: Institute API response status:",
        instituteResponse.status
      );

      if (!instituteResponse.ok) {
        const errorResult = await instituteResponse.json();
        console.error("Institute API error:", errorResult);

        if (instituteResponse.status === 401) {
          toast.error("Session expired. Please login again.");
          // Redirect to login based on user type
          window.location.href = `/login?userType=${userType}`;
          return;
        }
        throw new Error(
          `Failed to fetch institute details: ${
            errorResult.statusText || "Unknown error"
          }`
        );
      }

      const instituteResult = await instituteResponse.json();
      console.log("Debug: Institute result:", instituteResult);

      const institute = instituteResult.user;
      setInstituteData(institute);

      // ✅ Auto-set values if already accepted with duration & signDate
      if (
        institute.termsAccepted &&
        institute.mouDuration &&
        institute.signDate
      ) {
        setTermsAccepted(true);
        setInstituteForm((prev) => ({
          ...prev,
          mouDuration: institute.mouDuration,
          signDate: institute.signDate,
        }));
        setFormLocked(true); // custom state to disable fields
      }

      if (!institute.createdBy) {
        toast.error("No Chapter EM associated with this institute");
        return;
      }

      // Get current financial year
      const currentFinancialYear = getCurrentFinancialYear();
      console.log("Debug: Current financial year:", currentFinancialYear);
      console.log("Debug: Chapter EM ID:", institute.createdBy);

      // Fetch Terms and Conditions for this EM and financial year
      console.log("Debug: Fetching terms and conditions...");
      const termsResponse = await fetch(
        `${SERVER_ORIGIN}/api/terms/auth/active/${institute.createdBy}/${currentFinancialYear}`,
        {
          headers: {
            "auth-token": token,
          },
        }
      );

      console.log("Debug: Terms API response status:", termsResponse.status);

      if (termsResponse.ok) {
        const termsResult = await termsResponse.json();
        console.log("Debug: Terms result:", termsResult);

        const termsArray = termsResult.data;
        if (Array.isArray(termsArray) && termsArray.length > 0) {
          setTermsData(termsArray[0]);
        } else if (termsArray && !Array.isArray(termsArray)) {
          setTermsData(termsArray);
        } else {
          toast.info(
            "No Terms and Conditions found for current financial year"
          );
        }
      } else {
        const errorResult = await termsResponse.json();
        console.error("Terms API error:", errorResult);

        if (termsResponse.status === 401) {
          toast.error("Authentication failed. Please login again.");
          window.location.href = `/login?userType=${userType}`;
          return;
        } else if (termsResponse.status === 404) {
          toast.info(
            "No Terms and Conditions available for this institute in the current financial year"
          );
        } else {
          toast.error(
            errorResult.statusText || "Failed to load Terms and Conditions"
          );
        }
      }
    } catch (err) {
      console.error("Error fetching Terms and Conditions:", err);

      if (
        err.message.includes("No authentication token") ||
        err.message.includes("Token verification failed")
      ) {
        toast.error("Please login to continue");
        const currentUserType = sessionStorage.getItem("userType") || "em";
        window.location.href = `/login?userType=${currentUserType}`;
      } else {
        toast.error("Failed to load Terms and Conditions. Please try again.");
      }
    } finally {
      setIsLoadingTerms(false);
    }
  };

  const handleAcceptTerms = () => {
    setTermsAccepted(true);
    toast.success("Terms and Conditions accepted successfully");
  };

  const saveTermsAcceptance = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${SERVER_ORIGIN}/api/institute/auth/save-terms-acceptance`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": sessionStorage.getItem("token"),
          },
          body: JSON.stringify({
            _id: _id,
            termsAccepted: termsAccepted,
            termsId: termsData?._id,
            mouDuration: instituteForm.mouDuration,
            signDate: instituteForm.signDate,
            acceptanceDate: new Date().toISOString(),
          }),
        }
      );
      const result = await response.json();
      if (response.status >= 300) {
        throw new Error(result.statusText || "Failed to save terms acceptance");
      } else {
        toast.success(
          result.statusText || "Terms acceptance saved successfully"
        );
        handleClose2(); // Close the modal after successful save
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {show2 && (
        <Modal show={show2} onHide={handleClose2} size="xl">
          <Modal.Header closeButton>
            Terms and Conditions Agreement
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={6} className={userTypeModalCss.col1}>
                <SecCard>
                  <div className="my-3">
                    <b>Terms and Conditions for this Institute</b>
                  </div>

                  {isLoadingTerms && (
                    <div className="text-center p-4">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-2">Loading Terms and Conditions...</p>
                    </div>
                  )}

                  {!isLoadingTerms && !termsData && (
                    <Alert variant="warning">
                      <Alert.Heading>No Terms Found</Alert.Heading>
                      <p>
                        No Terms and Conditions found for this institute's
                        Chapter EM in the current financial year.
                      </p>
                    </Alert>
                  )}

                  {termsData && (
                    <div>
                      <div
                        className="mb-3 p-3"
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderRadius: "5px",
                        }}
                      >
                        <h6 className="mb-2" style={{ color: "#495057" }}>
                          Institute Information
                        </h6>
                        <div className="row">
                          <div className="col-md-12">
                            <small>
                              <strong>Institute:</strong> {instituteData?.name}
                            </small>
                          </div>
                          <div className="col-md-6">
                            <small>
                              <strong>Chapter EM:</strong>{" "}
                              {termsData.emData?.emName}
                            </small>
                          </div>
                          <div className="col-md-6">
                            <small>
                              <strong>Financial Year:</strong>{" "}
                              {termsData.financialYear}
                            </small>
                          </div>
                        </div>
                      </div>

                      <div className="mb-3">
                        <h5
                          style={{
                            color: "#0d5e9c",
                            borderBottom: "2px solid #0d5e9c",
                            paddingBottom: "5px",
                          }}
                        >
                          {termsData.title || "Terms and Conditions"}
                        </h5>
                        <div className="mb-2">
                          <small className="text-muted">
                            {/* Version: {termsData.version || 'N/A'} | */}
                            Status:{" "}
                            <span
                              className={`badge ${
                                termsData.status === "active"
                                  ? "bg-success"
                                  : "bg-secondary"
                              }`}
                            >
                              {termsData.status
                                ? termsData.status.toUpperCase()
                                : "UNKNOWN"}
                            </span>
                          </small>
                        </div>
                      </div>

                      <div
                        style={{
                          lineHeight: "1.6",
                          fontSize: "14px",
                          color: "#333",
                          maxHeight: "500px",
                          overflowY: "auto",
                          border: "1px solid #dee2e6",
                          padding: "20px",
                          borderRadius: "8px",
                          backgroundColor: "white",
                          marginBottom: "20px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: termsData.content || "No content available",
                        }}
                      />

                      <div className="mt-3">
                        <div
                          className="form-check d-flex align-items-center justify-content-center p-3"
                          style={{
                            backgroundColor: "#f8f9fa",
                            border: "2px solid #dee2e6",
                            borderRadius: "8px",
                            cursor: "pointer",
                          }}
                          onClick={() => setTermsAccepted(!termsAccepted)}
                        >
                          <input
                            className="form-check-input me-3"
                            type="checkbox"
                            id="acceptTerms"
                            checked={termsAccepted}
                            disabled={formLocked} // ✅ disable if already saved
                            onChange={(e) => setTermsAccepted(e.target.checked)}
                            style={{
                              transform: "scale(1.5)",
                              marginRight: "15px",
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="acceptTerms"
                            style={{
                              fontSize: "16px",
                              fontWeight: "600",
                              color: "#495057",
                              cursor: "pointer",
                              userSelect: "none",
                            }}
                          >
                            I have read and accept the Terms and Conditions
                          </label>
                        </div>

                        {termsAccepted && (
                          <Alert variant="success" className="text-center mt-3">
                            <strong>✓ Terms and Conditions Accepted</strong>
                            <br />
                            <small>
                              You can now proceed with the MOU process.
                            </small>
                          </Alert>
                        )}
                      </div>
                    </div>
                  )}
                </SecCard>
              </Col>
              <Col sm={6} className={userTypeModalCss.col1}>
                <SecCard className="m-0">
                  {!termsAccepted && termsData && (
                    <Alert variant="info">
                      <Alert.Heading>Terms Acceptance Required</Alert.Heading>
                      <p>
                        Please read and accept the Terms and Conditions on the
                        left before proceeding.
                      </p>
                    </Alert>
                  )}

                  <div style={{ marginBottom: "0.8rem" }}>
                    <label className={EM.chapterEMLabel} htmlFor="mouDuration">
                      Duration <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      className={EM.chapterEMInput}
                      id="mouDuration"
                      name="mouDuration"
                      value={instituteForm.mouDuration}
                      onChange={onChange}
                      //   disabled={!termsAccepted}
                      disabled={!termsAccepted || formLocked} // ✅ disable if locked
                    >
                      <option value="">-- Select Duration --</option>
                      <option value="1">1 Year</option>
                      <option value="2">2 Years</option>
                      <option value="3">3 Years</option>
                    </select>
                  </div>

                  <div style={{ marginBottom: "0.8rem" }}>
                    <label className={EM.chapterEMLabel} htmlFor="signDate">
                      Agreement Date <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="w-100">
                      {/* <DateSelect
                        selectedYear={instituteForm.signDate}
                        handleYearChange={handleInputChange}
                        className="w-100"
                        disabled={!termsAccepted}
                      /> */}
                      <DateInput
                        value={instituteForm.signDate}
                        onChange={handleInputChange}
                        disabled={!termsAccepted}
                      />
                    </div>
                  </div>

                  {termsAccepted && (
                    <div
                      className="mt-4 p-3"
                      style={{
                        backgroundColor: "#e8f5e8",
                        border: "1px solid #28a745",
                        borderRadius: "8px",
                      }}
                    >
                      <h6 style={{ color: "#155724", marginBottom: "10px" }}>
                        <strong>Agreement Summary</strong>
                      </h6>
                      <div className="row">
                        <div className="col-md-6">
                          <small>
                            <strong>Institute:</strong> {instituteData?.name}
                          </small>
                        </div>
                        <div className="col-md-6">
                          <small>
                            <strong>Duration:</strong>{" "}
                            {instituteForm.mouDuration
                              ? `${instituteForm.mouDuration} Year(s)`
                              : "Not selected"}
                          </small>
                        </div>
                        <div className="col-md-6">
                          <small>
                            <strong>Terms:</strong> {termsData?.title}
                          </small>
                        </div>
                        <div className="col-md-6">
                          {/* <small>
                            <strong>Date:</strong>{" "}
                            {instituteForm.signDate
                              ? new Date(
                                  instituteForm.signDate
                                ).toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "2-digit",
                                })
                              : "Not selected"}
                          </small> */}
                          <small>
                            <strong>Date:</strong>{" "}
                            {instituteForm.signDate
                              ? new Date(
                                  instituteForm.signDate
                                ).toLocaleDateString("en-GB")
                              : "Not selected"}
                          </small>

                          {/* <small><strong>Date:</strong> {instituteForm.signDate || 'Not selected'}</small> */}
                        </div>
                      </div>
                    </div>
                  )}

                  <div style={{ marginTop: "20px", textAlign: "center" }}>
                    <button
                      className={`btn btn-success btn-lg`}
                      onClick={saveTermsAcceptance}
                      //   disabled={
                      //     loading ||
                      //     !termsAccepted ||
                      //     !instituteForm.mouDuration ||
                      //     !instituteForm.signDate
                      //   }
                      disabled={
                        loading ||
                        !termsAccepted ||
                        !instituteForm.mouDuration ||
                        !instituteForm.signDate || 
                        formLocked // ✅ disable save if already locked
                      }
                      style={{
                        padding: "12px 30px",
                        fontSize: "16px",
                        fontWeight: "bold",
                        backgroundColor: "#28a745",
                        borderColor: "#28a745",
                      }}
                    >
                      {loading ? "Saving..." : "Save Agreement"}
                    </button>
                  </div>
                </SecCard>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      )}

      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        <SettingsOutlinedIcon />
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {/* <MenuItem onClick={handleClick2} key="invited-students">
          <FileUploadOutlinedIcon />
          Accept Terms and Conditions
        </MenuItem> */}

        <MenuItem onClick={handleInvitedStudents} key="invited-students">
          <RecentActorsOutlinedIcon />
          Invited Students
        </MenuItem>
        <MenuItem
          onClick={handleShareRegistrationLink}
          key="share-registration-link"
        >
          <ShareOutlinedIcon />
          Share Student Registration Link
        </MenuItem>
        <MenuItem
          onClick={handleManageAccounts}
          disableRipple
          key="manage-accounts"
        >
          <ManageAccountsOutlinedIcon />
          More Details
        </MenuItem>
        <MenuItem onClick={handleDeleteClick} disableRipple key="delete">
          <DeleteForeverOutlinedIcon />
          Delete
        </MenuItem>
      </StyledMenu>
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure, you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            No
          </Button>
          <Button onClick={handleDeleteConfirm} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
